import { render, staticRenderFns } from "./UpsellOptions.vue?vue&type=template&id=4e2744f6"
import script from "./UpsellOptions.vue?vue&type=script&lang=js"
export * from "./UpsellOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports